import {Component, Input} from "@angular/core";

@Component({
  selector: 'app-colorbox',
  templateUrl: './colorbox.component.html'
})
export class ColorboxComponent{

  @Input()
  color:number = 1;

  @Input()
  title: string;

  @Input()
  value:number;

  @Input()
  icon: string;

  @Input()
  toTranslate: boolean = false;

  @Input()
  isFontAwesome: boolean = false;

  @Input()
  customColor: string;

}
